import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TEditCommentSucceed, EEditCommentActionType, IEditCommentSucceedParams } from './types';

export const editCommentSucceed: (data: IEditCommentSucceedParams) => TEditCommentSucceed = actionGenerator<
  EEditCommentActionType.Succeed,
  IEditCommentSucceedParams
>(EEditCommentActionType.Succeed);
